export default __webpack_public_path__ + "static/media/email-notification-toolbox.450c4c87.svg";